"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var CHANNELS_URI = 'broadcast/v2/channels';

var ChannelsAPI =
/*#__PURE__*/
function () {
  function ChannelsAPI() {
    (0, _classCallCheck2.default)(this, ChannelsAPI);
  }

  (0, _createClass2.default)(ChannelsAPI, null, [{
    key: "getChannels",
    value: function getChannels() {
      return _apiClient.default.get(CHANNELS_URI);
    }
  }]);
  return ChannelsAPI;
}();

exports.default = ChannelsAPI;
module.exports = exports.default;